import { buildQueryParams, GENERIC_HEADERS } from '../vue/constants/requests';
const BASE_URL = '/a/myaccount/customers/address/';
export async function deleteAddress(customerId, hash, associateId, addressId) {
    const response = await fetch(`${BASE_URL}${buildQueryParams(customerId, hash, associateId)}`, { method: 'DELETE', headers: GENERIC_HEADERS, body: JSON.stringify({ id: addressId }) });
    if (!response.ok) {
        throw new Error('Error deleting address.');
    }
}
